<template>
  <div class="pop">
    <div class="questlist">
      <div class="top">题目</div>
      <p class="question">
        {{data.question}}
        <!-- <span>（{{data.questionscore}}分）</span> -->
      </p>
      <div class="middle">
        <table style="width:100%;text-align:center">
          <thead>
            <tr>
              <td>序号</td>
              <td>提交时间</td>
              <td>答案</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="item.eshistoryid">
              <td>{{(index+1)+(postdata.page-1)*postdata.size}}</td>
              <td>{{item.escreatetime|formatetime}}</td>
              <td>{{item.esuseranswer}}</td>
              <td>
                <button @click="toexam(item.eshistoryid)">查看试卷</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class style="text-align:right;margin-top:20px;">
          <Page
            :total="total"
            :page-size="postdata.size"
            :current="postdata.page"
            @on-change="changepage"
            @on-page-size-change="changesize"
            show-sizer
            show-elevator
            show-total
            :page-size-opts="[5,10, 20,50]"
          />
        </div>
      </div>
      <div class="albotttom">
        <Button style="margin-right:100px" @click="close">取消</Button>
        <div class="albuttom" @click="exported">导出Excel</div>
      </div>
    </div>
  </div>
</template>
<script>
import { ExamScore_getAnswer, ExamScore_export } from "../../assets/js/api.js";
export default {
  data() {
    return {
      list: [],
      postdata: {
        // 名称	类型	必填	参数位置	默认值	备注
        examid: this.examid, //	string	true	普通参数		考试id
        questionid: this.data.questionid, //	string	true	普通参数		试题id
        page: 1, //	string	true	普通参数		页数
        size: 5 //	string	true	普通参数		页码
      },
      total: null
    };
  },
  props: ["data", "examid"],
  mounted() {
    this.getlist();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    changepage(data) {
      this.postdata.page = data;
      this.getlist();
    },
    changesize(data) {
      this.postdata.page = 1;
      this.postdata.size = data;
      this.getlist();
    },
    toexam(data) {
      // this.errorPlus("此链接未联通");
      // /Recordtestpaper?id=100349
      this.$router.push("/Recordexampaper?id=" + data);
    },
    getlist() {
      ExamScore_getAnswer(this.postdata).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
        }
      });
    },
    exported() {
      ExamScore_export(this.postdata).then(res => {
        this.loadExcel(
          res.data,
          "试卷" +
            this.postdata.examid +
            "题目" +
            this.postdata.questionid +
            "导出"
        );
      });
      // this.errorPlus("亲，抱歉，暂时无法导出")
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.questlist {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8.73rem;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  padding: 0.3rem;
}
.top {
  height: 0.4rem;
  text-align: left;
  color: #3a4047;
  font-size: 0.24rem;
  line-height: 0.4rem;
}
.question {
  text-align: left;
  text-indent: 2em;
  line-height: 0.3rem;
  color: #676d78;
}
.middle {
  box-sizing: border-box;
  text-align: left;
  background: #f2f4f8;
  padding: 0.2rem;
  border-radius: 10px;
}
tr {
  height: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.14rem;
}
thead tr {
  color: #a3acbf;
}
tbody tr {
  background: #fff;
}
button {
  color: #ff064e;
  background: #ffd6de;
  border-radius: 0.5rem;
  border: none;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}

.bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 0.3rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  border-radius: 3px;
  line-height: 0.3rem;
  text-align: center;
  background: #ffd6de;
  color: #ff064e;
  font-size: 0.14rem;
  font-weight: bold;
}
.albotttom {
  display: flex;
  justify-content: center;
  margin-top: 0.3rem;
  line-height: 0.3rem;
}
.albotttom > div {
  width: 1rem;
  margin: 0 0.15rem;
}
.albuttom {
  height: 0.3rem;
  background: #5b48ff;
  color: #fff;
  font-size: 0.14rem;
  border-radius: 2px;
  line-height: 0.3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/questlists.vue